import { render } from "./NewCupon.vue?vue&type=template&id=2288c5b1&scoped=true"
import script from "./NewCupon.vue?vue&type=script&lang=js"
export * from "./NewCupon.vue?vue&type=script&lang=js"

import "./NewCupon.vue?vue&type=style&index=0&id=2288c5b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2288c5b1"]])

export default __exports__